import { useMatches, useNavigate } from 'react-router-dom'
import { useGuard, useUser } from '../../hooks/auth'

import {
  DashboardAlertMessage,
  DashboardhSmallButton,
  DashboardMessage,
  DashboardTooltip,
  Icon,
  Table,
} from 'bd-web-components'
import {
  Container,
  PageTitle,
  PageHeaderBox,
  ExceptionContainer,
  CalendarContiner,
  MainCard,
  MainCardDiv,
  LabelCard,
  IconDetailContainer,
  CardTitle,
  SubCard,
  SubIconDetailContainer,
  SubLabelCard,
  SubCardTitle,
  SubContainer,
  CalendarDashboardStyled,
  TableTag,
  TableTagValue,
  TagContainer,
  ButtonBox,
  TableContainer,
  SelectDateContainer,
  SelectDateText,
} from './styles'
import { useContext, useEffect, useRef, useState, useCallback } from 'react'
import Loader from '../../components/Loader'
import DateContext from '../../hooks/date'
import {
  PRIMARY_BLUE_01,
  PRIMARY_RED_02,
  PRIMARY_RED_03,
  SECONDARY_BLUE_01,
  SECONDARY_GREEN_07,
  SECONDARY_ORANGE_01,
  SECONDARY_YELLOW_01,
} from 'bd-web-components/src/utils/dash-colors'

import { DashboardFinancialDropdown } from 'bd-web-components'
import {
  financialCloseCreditAndDebit,
  financialResumeTransactions,
} from '../../utils/table-modeling'
import {
  EventData,
  ProducerResumeData,
  useGetProducerResume,
} from '../../hooks/financial-close-resume'
import { format } from 'date-fns'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import {
  ProducerResumeTransactions,
  useGetProducerResumeTransactions,
} from '../../hooks/financial-close-resume-transactions'
import { Breadcrumb } from '../../components/Breadcrumb'
import useBdApp from '../../hooks/bdapp/useBdApp'
import { getDashColor } from '../../styles'
import MaisShowBanner from '../../components/MaisShowBanner'

const subValues = [
  {
    color: 'black',
    icon: 'internet',
    title: 'Vendas Online',
    props: 'online_sale',
    background: PRIMARY_BLUE_01,
  },
  {
    color: 'red',
    icon: 'noInternet',
    title: 'Vendas Offline',
    props: 'offline_sale',
    background: PRIMARY_RED_02,
  },
  {
    color: 'yellow',
    icon: 'coins',
    title: 'Descontos',
    props: 'rebate',
    background: SECONDARY_YELLOW_01,
  },
  {
    color: 'orange',
    icon: 'businessIncreaseMoney',
    title: 'Saques Realizados',
    props: 'total_withdrawals',
    background: SECONDARY_ORANGE_01,
  },
]

const dateTipText = `
  Seleciona eventos de acordo com sua data de aconteceimento.
  Após selecionar um evento, todos os saques do evento serão visíveis.`

const titleTipText = `Os valores exibidos nesta tela podem levar até 30 minutos para serem atualizados, o que pode resultar em diferenças em relação aos valores informados no fechamento ou saque.`

const ResumeHeader = ({ resumeData, isLoading }: any) => {
  return (
    <>
      <DashboardAlertMessage
        mainMessage={
          'Para esses números consideramos a data de janeiro de 2024 em diante.'
        }
        subMessage={'Eventos anteriores a essa data não são considerados.'}
        iconName="report"
        closable={true}
      />
      <MainCardDiv>
        <MainCard>
          <IconDetailContainer className={'success'}>
            <div>
              <Icon
                fill={SECONDARY_GREEN_07}
                classes="icon-class-goldBar"
                iconName="goldBar"
                width={23}
                height={23}
              />
            </div>
          </IconDetailContainer>
          <LabelCard>
            <CardTitle>Saldo Total</CardTitle>
            {isLoading ? <Skeleton /> : resumeData.total_available}
          </LabelCard>
        </MainCard>
        <MainCard>
          <IconDetailContainer className={'info'}>
            <div>
              <Icon
                fill={SECONDARY_BLUE_01}
                classes="icon-class-goldBarBlock"
                iconName="goldBarBlock"
                width={23}
                height={23}
              />
            </div>
          </IconDetailContainer>
          <LabelCard>
            <CardTitle>Total de Vendas</CardTitle>
            {isLoading ? <Skeleton /> : resumeData.total_gmv}
          </LabelCard>
        </MainCard>
      </MainCardDiv>
      <div>
        <SubContainer>
          {subValues.map((item, i) => (
            <SubCard>
              <SubIconDetailContainer className={subValues[i].color}>
                {/* <div> */}
                <Icon
                  fill={subValues[i].background}
                  classes={`icon-class-${subValues[i].icon}`}
                  iconName={subValues[i].icon}
                  width={23}
                  height={23}
                />
                {/* </div> */}
              </SubIconDetailContainer>
              <SubLabelCard>
                <SubCardTitle>{subValues[i].title}</SubCardTitle>
                {isLoading ? <Skeleton /> : resumeData[subValues[i].props]}
              </SubLabelCard>
            </SubCard>
          ))}
        </SubContainer>
      </div>
    </>
  )
}

const resumeMOCK = {
  online_sale: '',
  offline_sale: '',
  rebate: '',
  total_gmv: '',
  total_available: '',
  total_withdrawals: '',
  events: [],
}

export function Resume() {
  // -----------------------------------------------------
  window.document.title = 'Área do Produtor'
  const user = useUser()
  const tabelaRef: any = useRef(null)
  const navigate = useNavigate()
  const { setStateDate, stateDate } = useContext(DateContext)
  const [page, setPage] = useState(1)
  const screenLimit = 762
  const [screenWidth, setScreenWidth] = useState(window.innerWidth)
  const [isMobile, setIsMobile] = useState<boolean>(screenWidth < screenLimit)
  const columns = financialCloseCreditAndDebit(isMobile)
  const transactionsColumns = financialResumeTransactions()

  // verify if user has permission to acess
  useGuard(['DP1', 'DP2', 'DP3', 'DP4', 'DP7'], () => {
    navigate('/events')
  })

  // -----------------------------------------------------

  let matches = useMatches()
  let crumbs = matches
    .filter((match: any) => Boolean(match.handle?.crumb))
    .map((match: any) => {
      return {
        name: match.handle.crumb(match.data),
        path: match.pathname,
      }
    })

  const handleWindowSizeChange = useCallback(() => {
    setScreenWidth(window.innerWidth)
  }, [])

  const newDate = new Date()
  const today = format(newDate, 'yyyy-MM-dd')
  const [tab, setTab] = useState<string>('events')
  const [active, setActive] = useState<string>('1')
  const [resumeData, setResumeData] = useState<ProducerResumeData>(resumeMOCK)
  const [transactionsData, setTransactionsData] =
    useState<ProducerResumeTransactions>({
      transactions: [],
      total_pages: 1,
    })
  const { resume, resumeLoading, resumeError } = useGetProducerResume(
    stateDate.startDate,
    stateDate.endDate,
    active
  )

  const handlePaginaChange = (page: any) => {
    setPage(page + 1)
    if (tabelaRef.current) {
      tabelaRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }

  const {
    resumeTransactions,
    resumeLoadingTransactions,
    resumeErrorTransactions,
  } = useGetProducerResumeTransactions(
    stateDate.startDate,
    stateDate.endDate,
    page,
    active
  )

  useEffect(() => { }, [setStateDate, today])

  useEffect(() => {
    if (resumeTransactions !== undefined) {
      setTransactionsData(resumeTransactions)
    }
  }, [resumeTransactions, resumeLoadingTransactions, resumeErrorTransactions])

  useEffect(() => {
    if (resume !== undefined) {
      setResumeData(resume)
    }
  }, [resume, resumeLoading, resumeError])

  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange)
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange)
    }
  }, [handleWindowSizeChange])

  useEffect(() => {
    setIsMobile(screenWidth < screenLimit)
  }, [screenWidth])

  useEffect(() => {
    if (user !== undefined) {
      if (user.clienteId === null) {
        navigate('/events')
      }
    }
  }, [user, navigate])

  const { isNative } = useBdApp()

  const changeTab = (value: string) => {
    setTab(value)
  }
  const changeAtive = (value: string) => {
    setActive(value)
  }

  return (
    <>
      <Container>
        <Breadcrumb paths={[...crumbs]} />
        <>
          <PageHeaderBox>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'flex-start',
              }}
            >
              <PageTitle>Visão Geral</PageTitle>
              <DashboardTooltip
                iconSize={{
                  desktop: 25,
                  mobile: 20,
                }}
                size={{
                  desktop: 25,
                  mobile: 20,
                }}
                iconName={'info180'}
                tip={titleTipText}
                position="down-left"
              />
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
              }}
            >
              <CalendarContiner>
                <CalendarDashboardStyled
                  className={resumeLoading ? 'hidden' : ''}
                />
              </CalendarContiner>
              <div style={resumeLoading ? { display: 'none' } : {}}>
                <DashboardTooltip
                  iconSize={{
                    desktop: 25,
                    mobile: 20,
                  }}
                  size={{
                    desktop: 25,
                    mobile: 20,
                  }}
                  iconName={'info180'}
                  tip={dateTipText}
                  position="down-right"
                />
              </div>
            </div>
          </PageHeaderBox>
        </>
        <MaisShowBanner />
        <div>
          {/* ERROR CASE */}
          {resumeError && (
            <ExceptionContainer height={400} margin={false}>
              <DashboardMessage
                isError={true}
                isImage={true}
                maintext={'Um erro aconteceu...'}
                subtext={'Já estamos trabalhando para corrigir o problema'}
              />
            </ExceptionContainer>
          )}
          {/* LOADING CASE */}
          {resumeLoading && (
            <>
              <SelectDateContainer>
                <SelectDateText
                  onClick={() => changeAtive('1')}
                  className={active === '1' ? 'active' : ''}
                >
                  Eventos Ativos
                </SelectDateText>
                <SelectDateText
                  onClick={() => changeAtive('0')}
                  className={active === '0' ? 'active' : ''}
                >
                  Eventos Inativos
                </SelectDateText>
              </SelectDateContainer>
              <br />
              <ResumeHeader resumeData={resumeData} isLoading={resumeLoading} />
              <ExceptionContainer height={400} margin={false}>
                <Loader />
              </ExceptionContainer>
            </>
          )}
          {/* SUCCESS CASE */}
          {resume && !resumeLoading && !resumeError && (
            <>
              <SelectDateContainer>
                <SelectDateText
                  onClick={() => changeAtive('1')}
                  className={active === '1' ? 'active' : ''}
                >
                  Eventos Ativos
                </SelectDateText>
                <SelectDateText
                  onClick={() => changeAtive('0')}
                  className={active === '0' ? 'active' : ''}
                >
                  Eventos Inativos
                </SelectDateText>
              </SelectDateContainer>
              <br />
              <ResumeHeader resumeData={resumeData} isLoading={resumeLoading} />
              <SelectDateContainer>
                <SelectDateText
                  onClick={() => changeTab('events')}
                  className={tab === 'events' ? 'active' : ''}
                >
                  Seus eventos
                </SelectDateText>
                <SelectDateText
                  onClick={() => changeTab('withdraw')}
                  className={tab === 'withdraw' ? 'active' : ''}
                >
                  Saques Realizados
                </SelectDateText>
              </SelectDateContainer>
              <br />
              {tab === 'events' && (
                <>
                  {resumeData.events !== undefined &&
                    resumeData.events.map((event: EventData) => {
                      const isPositive = event.total_available.includes('-')
                      const tableData: any[] = [
                        {
                          description: 'Venda online',
                          formatedValue: event.online_sale,
                        },
                        {
                          description: 'Venda offline',
                          formatedValue: event.offline_sale,
                        },
                        {
                          description: 'Descontos',
                          formatedValue: event.rebate,
                        },
                        {
                          description: 'Total de Saques',
                          formatedValue: event.total_withdrawals,
                        },
                      ]
                      return (
                        <DashboardFinancialDropdown
                          title={event.event_name}
                          subtitle={event.event_date}
                          value={event.total_available}
                          variant={'full'}
                          color={
                            !isPositive ? SECONDARY_GREEN_07 : PRIMARY_RED_03
                          }
                          tipText={'(Saldo Total)'}
                          open={true}
                        >
                          <Table
                            columns={columns}
                            data={tableData}
                            pageCount={0}
                          />
                          <TagContainer>
                            <TableTag>Total Vendas</TableTag>
                            <TableTagValue
                              className={!isPositive ? 'positive' : 'negative'}
                            >
                              {event.total_gmv}
                            </TableTagValue>
                          </TagContainer>
                          <ButtonBox>
                            <DashboardhSmallButton
                              onClick={() => navigate(`/${event.event_id}`)}
                              color="#fff"
                              background={getDashColor('SECONDARY_BLUE_01', 'SECONDARY_COLOR')}
                              height="36px"
                              maxWidth="100%"
                              variant="contained"
                              width="116px"
                              borderRadius="100px"
                            >
                              {'Ver Evento'}
                            </DashboardhSmallButton>
                            <div
                              style={{
                                width: '25px',
                              }}
                            />
                            {event.can_withdraw && !isNative && (
                              <DashboardhSmallButton
                                onClick={() =>
                                  navigate(
                                    `/events/${event.event_id}/withdraw/requests/list`
                                  )
                                }
                                color="#fff"
                                background={getDashColor('SECONDARY_BLUE_01', 'SECONDARY_COLOR')}
                                height="36px"
                                maxWidth="100%"
                                variant="contained"
                                width="125px"
                                borderRadius="100px"
                              >
                                {'Solicitar Saque'}
                              </DashboardhSmallButton>
                            )}
                          </ButtonBox>
                        </DashboardFinancialDropdown>
                      )
                    })}
                </>
              )}
            </>
          )}
          {resume &&
            resumeTransactions &&
            !resumeLoading &&
            !resumeError &&
            tab === 'withdraw' && (
              <div ref={tabelaRef}>
                {resumeLoadingTransactions && !resumeErrorTransactions && (
                  <Loader />
                )}
                {resumeErrorTransactions && !resumeLoadingTransactions && (
                  <ExceptionContainer height={400} margin={false}>
                    <DashboardMessage
                      isError={true}
                      isImage={true}
                      maintext={'Um erro aconteceu...'}
                      subtext={
                        'Já estamos trabalhando para corrigir o problema'
                      }
                    />
                  </ExceptionContainer>
                )}
                {resumeTransactions &&
                  !resumeLoadingTransactions &&
                  !resumeErrorTransactions && (
                    <TableContainer>
                      <Table
                        columns={transactionsColumns}
                        data={transactionsData.transactions}
                        pageCount={
                          transactionsData.total_pages === 1
                            ? 0
                            : transactionsData.total_pages
                        }
                        initialPage={page - 1}
                        onPageChange={handlePaginaChange}
                      />
                    </TableContainer>
                  )}
              </div>
            )}
        </div>
      </Container>
    </>
  )
}
